import MMNavigationRoutes from "./navigationRoutes";
import memberlistpage from "@/projects/Civi_Circle_Admin/pages/MemberListPage";
import memberformpage from "@/projects/Civi_Circle_Admin/pages/MemberFormPage";
import chapterprofilepage from "@/projects/Civi_Circle_Admin/pages/ChapterProfilePage";
import chapterprofilelistpage from "@/projects/Civi_Circle_Admin/pages/ChapterProfileListPage";
import eventslistpage from "@/projects/Civi_Circle_Admin/pages/EventsListPage";
import eventspage from "@/projects/Civi_Circle_Admin/pages/EventsPage";
import sponsorshiplistpage from "@/projects/Civi_Circle_Admin/pages/SponsorshipListPage";
import sponsorshipformpage from "@/projects/Civi_Circle_Admin/pages/SponsorshipFormPage";
import DonationFormPage from "../pages/Donationformpage";
import Donationlistpage from "../pages/Donationlistpage";
import VolunteeringListPage from "../pages/Volunteeringlistpage";
import VolunteeringFormPage from "../pages/Volunteeringformpage";
import Dashboard from "../pages";
import SignUpPage from "../pages/SignUpPage";
import ChapterTypePage from "../pages/ListTable/ChapterTypePage";
import AddChapterType from "../pages/ListTable/AddChapterType";
import AddLegalStatusPage from "../pages/ListTable/AddLegalStatusPage";
import LegalStatusList from "../pages/ListTable/LegalStatusList";
import SettingsListPage from "../pages/SettingsListPage";
import SettingsFormPage from "../pages/SettingsListPage/SettingsPage";
import InvitePage from "../pages/InvitePage/InvitePage";
import MemberPrefixList from "../pages/ListTable/MemberPrefix";
import AddMemberPrefixPage from "../pages/ListTable/AddMemberPrefix";
import MemberSuffixList from "../pages/ListTable/MemberSuffix";
import AddMemberSuffixPage from "../pages/ListTable/AddMemberSuffix";
import DepartmentListPage from "../pages/DepartmentListPage";
import DepartmentFormPage from "../pages/DepartmentFormPage";
import PositionList from "../pages/ListTable/PositionList";
import AddPositionPage from "../pages/ListTable/AddPosition";
import GovernmentIdList from "../pages/ListTable/GovernmentIdList";
import AddGovernmentIdPage from "../pages/ListTable/AddGovernmentIdPage";
import AdminLoginPage from "../pages/LoginPage";
import Relationship from "../pages/Relationship";
import ChatPage from "../pages/ChatPage";
import SOPLibrary from "../pages/SOPLibrary";
import SOPLibraryList from "../pages/SOPLibraryList";
import Auth from "../pages/AdminLogin";
import CityCollaborations from "../pages/CityCollaborations";
import FeedCreation from "../pages/FeedCreation";
import ErrorLogs from "../pages/ErrorLogs";
import routes from "@/utils/routes";

const rootProtectedRoutes = routes.find(r => r.type === "auth")?.routes ?? [];

const MMRoutes: Record<string, any> = {
  signup: {
    path: MMNavigationRoutes.ADMIN_SIGNUP,
    element: SignUpPage,
    name: "Admin Signup",
  },
  adminlogin: {
    path: MMNavigationRoutes.ADMIN_LOGIN,
    component: AdminLoginPage,
    name: "Admin Login",
  },
  adminloginpage: {
    path: MMNavigationRoutes.ADMIN_LOGIN_PAGE,
    component: Auth,
    name: "Admin Login Page",
  },
  dashboard: {
    path: MMNavigationRoutes.DASHBOARD,
    component: Dashboard,
    name: "Dashboard",
  },
  feedcreation: {
    path: MMNavigationRoutes.FEED_CREATION,
    component: FeedCreation,
    name: "Feed Creation",
  },

  memberlist: {
    path: MMNavigationRoutes.MEMBER_LIST,
    component: memberlistpage,
    name: "Member List",
  },
  chapterprofilelist: {
    path: MMNavigationRoutes.CHAPTER_PROFILE_LIST,
    component: chapterprofilelistpage,
    name: "Chapter Profile List",
  },
  createmember: {
    path: MMNavigationRoutes.CREATE_MEMBER,
    component: memberformpage,
    name: "Create Member",
  },
  editchapterprofile: {
    path: MMNavigationRoutes.EDIT_CHAPTER_PROFILE_ROUTE,
    component: chapterprofilepage,
    name: "Edit Chapter Profile",
  },
  chapterprofile: {
    path: MMNavigationRoutes.CHAPTER_PROFILE,
    component: chapterprofilepage,
    name: "Chapter Profile",
  },
  editmember: {
    path: MMNavigationRoutes.EDIT_MEMBER_ROUTE,
    component: memberformpage,
    name: "Edit Member",
  },
  eventslist: {
    path: MMNavigationRoutes.EVENTS_LIST,
    component: eventslistpage,
    name: "Events List",
  },
  createevent: {
    path: MMNavigationRoutes.CREATE_EVENT,
    component: eventspage,
    name: "Create Event",
  },
  editevent: {
    path: MMNavigationRoutes.EDIT_EVENT_ROUTE,
    component: eventspage,
    name: "Edit Event",
  },
  sponsorshiplist: {
    path: MMNavigationRoutes.SPONSORSHIP_LIST,
    component: sponsorshiplistpage,
    name: "Sponsorship List",
  },
  settingslist: {
    path: MMNavigationRoutes.SETTINGS_LIST,
    component: SettingsListPage,
    name: "Settings List",
  },
  createsettings: {
    path: MMNavigationRoutes.CREATE_SETTINGS,
    component: SettingsFormPage,
    name: "Create Settings",
  },
  editsettings: {
    path: MMNavigationRoutes.EDIT_SETTINGS_ROUTE,
    component: SettingsFormPage,
    name: "Edit Settings",
  },
  createsponsorship: {
    path: MMNavigationRoutes.CREATE_SPONSORSHIP,
    component: sponsorshipformpage,
    name: "Create Sponsorship",
  },
  editsponsorship: {
    path: MMNavigationRoutes.EDIT_SPONSORSHIP_ROUTE,
    component: sponsorshipformpage,
    name: "Edit Sponsorship",
  },
  donationlist: {
    path: MMNavigationRoutes.DONATION_LIST,
    component: Donationlistpage,
    name: "Donation List",
  },
  createdonation: {
    path: MMNavigationRoutes.CREATE_DONATION,
    component: DonationFormPage,
    name: "Create Donation",
  },
  editdonation: {
    path: MMNavigationRoutes.EDIT_DONATION_ROUTE,
    component: DonationFormPage,
    name: "Edit Donation",
  },
  volunteeringlist: {
    path: MMNavigationRoutes.VOLUNTEERING_LIST,
    component: VolunteeringListPage,
    name: "Volunteering List",
  },
  createvolunteering: {
    path: MMNavigationRoutes.CREATE_VOLUNTEERING,
    component: VolunteeringFormPage,
    name: "Create Volunteering",
  },
  editvolunteering: {
    path: MMNavigationRoutes.EDIT_VOLUNTEERING_ROUTE,
    component: VolunteeringFormPage,
    name: "Edit Volunteering",
  },

  createrelationship: {
    path: MMNavigationRoutes.CREATE_RELATIONSHIP,
    component: Relationship,
    name: "Create Relationships",
  },
  editrelationship: {
    path: MMNavigationRoutes.EDIT_RELATIONSHIP_ROUTE,
    component: Relationship,
    name: "Edit Relationships",
  },
  chaptertype: {
    path: MMNavigationRoutes.CHAPTER_TYPE,
    component: ChapterTypePage,
    name: "Chapter Type",
  },
  addchaptertype: {
    path: MMNavigationRoutes.ADD_CHAPTER_TYPE,
    component: AddChapterType,
    name: "Add Chapter Type",
  },
  editchaptertype: {
    path: MMNavigationRoutes.EDIT_CHAPTER_TYPE_ROUTE,
    component: AddChapterType,
    name: "Edit Chapter Type",
  },

  legalstatus: {
    path: MMNavigationRoutes.LEGAL_STATUS,
    component: LegalStatusList,
    name: "Legal Status",
  },
  addlegalstatus: {
    path: MMNavigationRoutes.ADD_LEGAL_STATUS,
    component: AddLegalStatusPage,
    name: "Add Legal Status",
  },
  editlegalstatus: {
    path: MMNavigationRoutes.EDIT_LEGAL_STATUS_ROUTE,
    component: AddLegalStatusPage,
    name: "Edit Legal Status",
  },

  invite: {
    path: MMNavigationRoutes.INVITE_ROUTE,
    component: InvitePage,
    name: "Invite",
  },

  memberprefix: {
    path: MMNavigationRoutes.MEMBER_PREFIX,
    component: MemberPrefixList,
    name: "Member Prefix",
  },
  addmemberprefix: {
    path: MMNavigationRoutes.ADD_MEMBER_PREFIX,
    component: AddMemberPrefixPage,
    name: "Add Member Prefix",
  },
  editmemberprefix: {
    path: MMNavigationRoutes.EDIT_MEMBER_PREFIX_ROUTE,
    component: AddMemberPrefixPage,
    name: "Edit Member Prefix",
  },

  membersuffix: {
    path: MMNavigationRoutes.MEMBER_SUFFIX,
    component: MemberSuffixList,
    name: "Member Suffix",
  },
  addmembersuffix: {
    path: MMNavigationRoutes.ADD_MEMBER_SUFFIX,
    component: AddMemberSuffixPage,
    name: "Add Member Suffix",
  },
  editmembersuffix: {
    path: MMNavigationRoutes.EDIT_MEMBER_SUFFIX_ROUTE,
    component: AddMemberSuffixPage,
    name: "Edit Member Suffix",
  },
  department: {
    path: MMNavigationRoutes.DEPARTMENT,
    component: DepartmentListPage,
    name: "Department",
  },
  adddepartment: {
    path: MMNavigationRoutes.ADD_DEPARTMENT,
    component: DepartmentFormPage,
    name: "Add Department",
  },
  editdepartment: {
    path: MMNavigationRoutes.EDIT_DEPARTMENT_ROUTE,
    component: DepartmentFormPage,
    name: "Edit Department",
  },

  position: {
    path: MMNavigationRoutes.POSITION,
    component: PositionList,
    name: "Position",
  },
  addposition: {
    path: MMNavigationRoutes.ADD_POSITION,
    component: AddPositionPage,
    name: "Add Position",
  },
  editposition: {
    path: MMNavigationRoutes.EDIT_POSITION_ROUTE,
    component: AddPositionPage,
    name: "Edit Position",
  },
  governmentid: {
    path: MMNavigationRoutes.GOVERNMENT_ID,
    component: GovernmentIdList,
    name: "Government ID",
  },
  addgovernmentid: {
    path: MMNavigationRoutes.ADD_GOVERNMENT_ID,
    component: AddGovernmentIdPage,
    name: "Add Government ID",
  },
  editgovernmentid: {
    path: MMNavigationRoutes.EDIT_GOVERNMENT_ID_ROUTE,
    component: AddGovernmentIdPage,
    name: "Edit Government ID",
  },
  chatpage: {
    path: MMNavigationRoutes.CHAT_PAGE,
    component: ChatPage,
    name: "Chat Page",
  },

  sopslist: {
    path: MMNavigationRoutes.SOP_LIBRARY,
    component: SOPLibraryList,
    name: "SOP Library List",
  },
  createsop: {
    path: MMNavigationRoutes.CREATE_SOP,
    component: SOPLibrary,
    name: "Create SOP",
  },
  editsop: {
    path: MMNavigationRoutes.EDIT_SOP_ROUTE,
    component: SOPLibrary,
    name: "Edit SOP",
  },
  departmentlist: {
    path: MMNavigationRoutes.DEPARTMENT_LIST,
    component: DepartmentListPage,
    name: "Department List",
  },
  citycollaborations: {
    path: MMNavigationRoutes.CITY_COLLABORATIONS,
    component: CityCollaborations,
    name: "City Collaborations",
  },
  errorlogs: {
    path: MMNavigationRoutes.ERROR_LOGS,
    component: ErrorLogs,
    name: "Error Logs",
  },
};

// Merge root protected routes into MMRoutes
rootProtectedRoutes.forEach((route, index) => {
  const key = `root-${index}`;
  if (!Object.values(MMRoutes).some(r => r.path === route.path)) {
    MMRoutes[key] = {
      path: route.path,
      component: route.element,
      name: route.name,
    };

    // Add alias for /tenant/ paths if they don't exist
    if (route.path.startsWith("/tenant/")) {
      const aliasPath = route.path.replace("/tenant/", "/");
      const aliasKey = `root-alias-${index}`;
      if (!Object.values(MMRoutes).some(r => r.path === aliasPath)) {
        MMRoutes[aliasKey] = {
          path: aliasPath,
          component: route.element,
          name: `${route.name} (Alias)`,
        };
      }
    }
  }
});

export default MMRoutes;
